<template>
  <div :class="[$style.Container, isMobileUa ? $style.MobileContainer : '']">
    <template v-if="!props.loading">
      <slot name="header">
        <div :class="$style.Header">
          <img
            style="width: 31px; height: 19.7px; margin-left: 16px"
            src="https://static.lingvisions.com/public/a8d66af63e954f4a9185920943edd75a.svg"
          />
          <a :class="$style.Question" target="_blank" href="https://www.lingvisions.com/cases/20">
            常见问题
          </a>
        </div>
      </slot>
      <div :class="$style.Title">{{ props.listTitle || list.title }}</div>
      <!-- <img :class="$style.Title" :src="list.titleImaUrl" />-->
      <div
        :class="$style.Item"
        :style="{
          borderRadius: list.texts.length === 1 ? '20px' : undefined,
        }"
      >
        <div v-for="item in list.texts" :key="item.title">
          <img
            src="https://static.lingvisions.com/public/ee267cdfe99347c186651eb9230f90d2.svg"
            style="width: 16px; height: 16px; margin-right: 4px"
          />

          <div :class="$style.ItemText">{{ item.title }}</div>
        </div>
      </div>

      <div :class="$style.Info">
        <div
          v-for="(item, index) in list.infos"
          :class="animated ? undefined : $style.InfoItemAnimation"
          :style="
            animated
              ? undefined
              : {
                  animationDelay: `${index * 200}ms`,
                }
          "
          :key="index"
        >
          <img
            style="width: 16px; height: 16px; margin-right: 4px"
            src="https://static.lingvisions.com/public/497d18b491de4e5b9e62aac94da233f0.svg"
          />
          <div :class="$style.Tip">{{ item.title }}</div>
        </div>
      </div>
      <!-- <div :class="$style.Footer">
        
      </div> -->
    </template>
    <slot name="footer"></slot>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue';
  import { CheckOutlined } from '@ant-design/icons-vue';
  import { SKU_TYPE } from '../../constants';
  import { getIsMobileUa } from '../../utils/ua';
  import Mobile from './mobile.vue';

  const isMobileUa = getIsMobileUa();
  interface Props {
    isPersonal: boolean;
    loading?: boolean;
    amount: any;
    price: any;
    expiresIn?: string;
    seatNum?: string;
    listTitle?: string;
    crawlLimit?: string;
    insertTexts?: { title: string }[];
  }

  const list = computed(() => ({
    title: 'POD套餐专属',
    texts: [
      ...(props.insertTexts || []),
      {
        title:
          (+props.amount < 10000 ? `${+props.amount}灵豆` : `${+props.amount / 10000}万灵豆`) +
          `，每灵豆仅 ${(+props.price / +props.amount).toFixed(2)}元`,
      },
    ],
    infos: [
      {
        title: `${props.expiresIn}天超长有效期`,
      },
      {
        title: '批量采集/裂变/抠图/套版',
      },
      {
        title: '4通道任务高速并行',
      },
      {
        title: '超大存储空间，限免',
      },
      {
        title: `团队成员共享会员权益，上限${props.seatNum || 20}人`,
      },
      {
        title: `单日采集数量${props.crawlLimit}条`,
      },
    ],
  }));

  const props = defineProps<Props>();
  const animated = ref(false);

  watch(
    () => props.loading,
    (v) => {
      if (v) {
        setTimeout(() => {
          animated.value = true;
        }, 2000);
      }
    },
    {
      immediate: true,
    }
  );
</script>

<style lang="less" module>
  .Container {
    width: 312px;
    position: relative;
    padding: 24px 16px 0;
    background: url(https://static.lingvisions.com/public/7e6854878adc4c75b0b00694eb567016.png)
      center/cover no-repeat #225849;
    border-radius: 16px 0 0 16px;
  }

  .Title {
    margin-top: 64px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0%;
    color: rgba(255, 255, 255, 1);
    margin-left: 16px;
  }

  .Header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 22px;
  }

  .Item {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.1);
    margin-top: 34px;
    padding: 8px 0 8px 16px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .ItemText {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .Info {
    margin-top: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      margin-left: 16px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .InfoItemAnimation {
    animation: fade-in 0.5s ease forwards;
    opacity: 0;
    transform: translateX(-10px);
  }

  .Footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 32px;
    left: 0;
  }

  .Question {
    font-weight: 500;
    font-size: 12px;
    line-height: 1;
    letter-spacing: 0%;
    cursor: pointer;
    color: rgba(255, 255, 255, 1) !important;

    &:hover {
      color: #d16c44 !important;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateX(-10px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .MobileContainer {
    padding: 24px;
    background: url(https://static.lingvisions.com/public/75ed34b352734637a71336c8d1d31261.png)
      center/cover no-repeat #225849;

    .Header {
      display: none;
    }

    .Title {
      font-family: PingFang SC;
      font-weight: 600;
      font-style: Semibold;
      font-size: 16px;
      leading-trim: NONE;
      line-height: 16px;
      letter-spacing: 0%;
      vertical-align: middle;
      margin-top: 0;
      margin-left: 0;
    }

    .Item {
      margin-top: 24px;
    }

    .ItemText {
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      vertical-align: middle;
    }

    .Info {
      margin-top: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      vertical-align: middle;
    }
  }
</style>
